"use strict";
function isNode(object) {
  return !!(object && (typeof Node === "function" ? object instanceof Node : typeof object === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string"));
}
module.exports = isNode;
